/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-data': {
    width: 12,
    height: 12,
    viewBox: '0 0 12 12',
    data: '<path pid="0" d="M11.875 10.375H1.125V.625A.125.125 0 001 .5H.125A.125.125 0 000 .625v10.75c0 .069.056.125.125.125h11.75a.125.125 0 00.125-.125V10.5a.125.125 0 00-.125-.125zM2.5 7.437a1 1 0 102 0 1 1 0 00-2 0zm1.844-3.5a.75.75 0 101.5 0 .75.75 0 00-1.5 0zM6.812 7.5a1.5 1.5 0 103 0 1.5 1.5 0 00-3 0zm2.313-4.906a.875.875 0 101.75 0 .875.875 0 00-1.75 0z" _fill="#595959" fill-rule="nonzero"/>'
  }
})
